import type { Hasher } from "@hash/shared";

/**
 * Account-state badge for a hasher. "claimed" is the normal, expected state, so
 * it shows no badge — only the states that distinguish a hasher who can't log
 * in yet get one: "lite" (no phone) and "unclaimed" (vouched, not yet claimed).
 */
export function AccountStateBadge({ state }: { state: Hasher["accountState"] }) {
  if (state === "claimed") return null;
  const styles: Record<Exclude<Hasher["accountState"], "claimed">, string> = {
    lite: "bg-slate-100 text-slate-500",
    unclaimed: "bg-amber-100 text-amber-700",
  };
  return (
    <span
      className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${styles[state]}`}
    >
      {state}
    </span>
  );
}

/**
 * Marks a hasher who holds a misman role on one or more kennels. Shown in the
 * roster and on the manage screen; the per-kennel grants are managed under the
 * hasher's Manage view.
 */
export function MismanBadge() {
  return (
    <span className="shrink-0 rounded-full bg-indigo-100 px-2 py-0.5 text-xs font-medium text-indigo-700">
      misman
    </span>
  );
}
